import { ActivityType } from 'interfaces/common.interface';
import { t } from 'services/i18n.service';
import { useAppSelectorShallow } from 'store/hooks';
import HabitPackActivityList from 'pages/marketplace/HabitPackActivityList';

interface ActivityListProps {
  category: 'morning' | 'evening' | 'break' | 'standalone';
  title: string;
  activities: ActivityType[];
}

const ActivityList = ({ category, title, activities }: ActivityListProps) =>
  activities.length ? (
    <HabitPackActivityList
      allowAddToRoutine={false}
      category={category}
      title={title}
      habitActivities={activities}
    />
  ) : null;

const HabitPackPreviewBody = () => {
  const currentViewedPack = useAppSelectorShallow(
    (state) => state.habitPack.currentViewedPack
  );

  if (!currentViewedPack) {
    return null;
  }

  return (
    <div className='w-full flex flex-col gap-6'>
      <ActivityList
        category='morning'
        title={t('market.morning_habits')}
        activities={currentViewedPack.morning_activities ?? []}
      />
      <ActivityList
        category='evening'
        title={t('market.evening_habits')}
        activities={currentViewedPack.evening_activities ?? []}
      />
      <ActivityList
        category='break'
        title={t('market.break_activities')}
        activities={currentViewedPack.break_activities ?? []}
      />
      <ActivityList
        category='standalone'
        title={t('market.standalone_activities')}
        activities={currentViewedPack.standalone_activities ?? []}
      />
    </div>
  );
};

export default HabitPackPreviewBody;
